/* HomeMedix product card behaviour — "+ Add" → − qty + stepper.
   Uses /cart/add.js (first add) and /cart/change.js (±), updates the cart icon bubble and
   cart drawer contents via Section Rendering without opening the drawer. Falls back to the
   normal form post if the API call fails. Loaded once per page (guarded).
   Oct 14 2026: cards re-sync from /cart.js whenever the cart changes somewhere else (cart drawer or cart page
   quantity / Remove): Dawn's pub/sub "cart-update" event, plus a watch on the header cart bubble (Dawn re-renders
   it on every cart change) as a fallback. A sync that started before a newer card action is ignored. */
(function () {
  if (window.hmcInit) return;
  window.hmcInit = true;
  var SECTIONS = 'cart-icon-bubble,cart-drawer';
  var q = function (s, r) { return (r || document).querySelector(s); };
  var gen = 0, syncT = 0, hooked = false, watched = null;

  function refresh(sections, itemCount) {
    try {
      if (sections && sections['cart-icon-bubble']) {
        var b = document.getElementById('cart-icon-bubble');
        if (b) {
          var d = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var n = q('.shopify-section', d) || d.body;
          b.innerHTML = n.innerHTML;
        }
      }
      if (sections && sections['cart-drawer']) {
        var dr = q('cart-drawer');
        if (dr) {
          var d2 = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var inner = q('#CartDrawer', d2), cur = q('#CartDrawer', dr);
          if (inner && cur) {
            cur.innerHTML = inner.innerHTML;
            var ov = q('#CartDrawer-Overlay', dr);
            if (ov && typeof dr.close === 'function') ov.addEventListener('click', dr.close.bind(dr));
          }
          if (typeof itemCount === 'number') dr.classList.toggle('is-empty', itemCount === 0);
        }
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('hmc:cart', { detail: { item_count: itemCount } }));
  }

  function setQty(card, n) {
    var add = q('[data-hmc-add]', card), st = q('[data-hmc-step]', card), out = q('[data-hmc-qty]', card);
    if (!add || !st) return;
    if (n > 0) { add.hidden = true; st.hidden = false; out.textContent = n; }
    else { st.hidden = true; add.hidden = false; }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }

  function sync() {
    var g = gen;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (g !== gen) return; // a card action ran meanwhile; its own refresh triggers a fresh sync
        var map = {};
        (cart.items || []).forEach(function (i) {
          if (i.properties && Object.keys(i.properties).length) return; // Rx / custom lines are not steppable
          map[i.variant_id] = (map[i.variant_id] || 0) + i.quantity;
        });
        document.querySelectorAll('[data-hmc][data-variant-id]').forEach(function (c) {
          if (!c.classList.contains('is-busy')) setQty(c, map[c.dataset.variantId] || 0);
        });
      }).catch(function () {});
  }
  function syncSoon() { clearTimeout(syncT); syncT = setTimeout(sync, 150); }

  function hook() {
    if (!hooked && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      hooked = true;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { syncSoon(); });
    }
    var b = document.getElementById('cart-icon-bubble');
    if (b && b !== watched && window.MutationObserver) {
      watched = b;
      new MutationObserver(syncSoon).observe(b, { childList: true, subtree: true, characterData: true });
    }
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-hmc-add]'), inc = e.target.closest('[data-hmc-inc]'), dec = e.target.closest('[data-hmc-dec]');
    if (!add && !inc && !dec) return;
    var card = e.target.closest('[data-hmc]'), vid = card && card.dataset.variantId;
    if (!vid) return;
    e.preventDefault();
    if (card.classList.contains('is-busy')) return;
    card.classList.add('is-busy');
    gen++;
    var cur = parseInt(q('[data-hmc-qty]', card).textContent, 10) || 0;
    var next = add ? 1 : cur + (inc ? 1 : -1);
    var p = (add || cur === 0)
      ? post('/cart/add.js', { items: [{ id: parseInt(vid, 10), quantity: 1 }], sections: SECTIONS }).then(function (res) { return { sections: res.sections, count: null }; })
      : post('/cart/change.js', { id: vid, quantity: next, sections: SECTIONS }).then(function (res) { return { sections: res.sections, count: res.item_count }; });
    p.then(function (r) {
      setQty(card, next);
      refresh(r.sections, r.count === null ? Math.max(1, next) : r.count);
    }).catch(function () {
      if (add) { var f = q('[data-hmc-form]', card); if (f) f.submit(); }
    }).finally(function () { card.classList.remove('is-busy'); });
  });

  function boot() { hook(); sync(); }
  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState !== 'loading') boot();
})();
